import * as config from './../config/config'
import api from './interceptor'

export async function upload_bc(formData) {
    try {
        const response = await api.post(
            config.REACT_APP_ENDPOINT_MOBILE_COMMANDE, // 👈 endpoint upload
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
}